import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=2b0160e4&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"
import style0 from "./spinner.vue?vue&type=style&index=0&id=2b0160e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0160e4",
  null
  
)

export default component.exports